module.exports = __webpack_public_path__ + "img/icon-light-bulb.38e2f14b.svg";